<template>
  <div></div>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'Logout',
  created () {
    Vue.deleteLocalStorage('session')
    Vue.deleteLocalStorage('routes')
    this.$router.push('/')
  }
}
</script>

<style scoped>

</style>
